const deleteSites = {
  toastr: 'Deleted site',
  toastr1: ' successfully deleted'
};

export default deleteSites;
